<template>
    <div v-if="isVisible" class="o-step">
        <div class="o-step__inner">
            <StepIntro v-if="step.type === 'intro'" :step="step" />
            <MultipleChoice v-if="step.type === 'multiple_choice'" :step v-model:attempts="attempts" />
            <MultipleChoiceImages v-if="step.type === 'multiple_choice_images'" :step v-model:attempts="attempts" />
            <Order v-if="step.type === 'order'" :step v-model:attempts="attempts" />
            <Audio v-if="step.type === 'audio'" :step />
            <OrderImages v-if="step.type === 'order_images'" :step v-model:attempts="attempts" />
            <DragDropOnImage v-if="step.type === 'drag_drop_on_image'" :step v-model:attempts="attempts" />
            <Checklist v-if="step.type === 'checklist'" :step />
            <Completed v-if="step.type === 'completed'" :step :moduleTitle />
        </div>
    </div>
</template>

<script setup>
// Components
import StepIntro from '../molecules/StepIntro.vue';
import MultipleChoice from '../molecules/MultipleChoice.vue';
import MultipleChoiceImages from '../molecules/MultipleChoiceImages.vue';
import Order from '../molecules/Order.vue';
import Audio from '../molecules/Audio.vue';
import OrderImages from '../molecules/OrderImages.vue';
import DragDropOnImage from '../molecules/DragDropOnImage.vue';
import Checklist from '../molecules/Checklist.vue';
import Completed from '../molecules/Completed.vue';

const props = defineProps({
    step: Object,
    isVisible: Boolean,
    moduleTitle: String
});

const attempts = defineModel( 'attempts' );
</script>